module.exports = __webpack_public_path__ + "img/barbados.0566eebc.svg";